export enum DelayType {
    delay7days = "7_days",
    delay15days = "15_days",
    delay30days = "30_days",
    delay45days = "45_days",
    delay60days = "60_days",
    delay90days = "90_days",
    delay120days = "120_days",
    delay180days = "180_days",
    noLimit = "0_days"
}

export const delayTypeAsString = (type: DelayType | string): string => {
    switch (type) {
        case DelayType.delay7days:
            return '7 jours';
        case DelayType.delay15days:
            return '15 jours';
        case DelayType.delay30days:
            return '1 mois';
        case DelayType.delay45days:
            return '45 jours';
        case DelayType.delay60days:
            return '2 mois';
        case DelayType.delay90days:
            return '3 mois';
        case DelayType.delay120days:
            return '4 mois';
        case DelayType.delay180days:
            return '6 mois';
        case DelayType.noLimit:
            return 'Sans limite';
        default:
            return '';
    }
};